import {
    createColumnHelper,
    getCoreRowModel,
    useReactTable,
    getSortedRowModel
} from '@tanstack/react-table'
import React, { useCallback, useState } from 'react'
// import { tabledata } from './tableNewData'

import ReactTable from '../../../components/ReactTable'
import { Dropdown } from 'react-bootstrap'
import Pagination from '../../../components/Pagination'

const AppellantComponent = ({ jobAppellantDataList }) => {

    const [DataLimit, setDataLimit] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [TotalPagies, setTotalPagies] = useState(1)

    let totalAppellents = jobAppellantDataList.length;
    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }
    const [sorting, setSorting] = useState([])
    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.accessor((row) => row.profilePic, {
            id: 'profilePic',
            header: 'Image',
            cell: (row) => {
                return <img src={row.row.original.profilePic} alt="" />
            }
        }),
        columnHelper.accessor((row) => row.userName, {
            id: 'userName',
            header: 'Name',
            cell: (row) => {
                return <p>{row.row.original.userName}</p>
            }
        }),

        columnHelper.accessor((row) => row.jobApplicationStatus, {
            id: 'jobApplicationStatus',
            header: 'Status',
            cell: (row) => {
                let flag = row.row.original.jobApplicationStatus
                return (
                    <p
                        className={`labels ${
                            flag === 'Pending'
                                ? 'pending'
                                : flag === 'Selected'
                                ? 'selected'
                                : flag === 'To interview'
                                ? 'tointerview'
                                : flag === 'Hold'
                                ? 'hold'
                                : flag === 'Rejected'
                                ? 'rejected'
                                : ''
                        }`}
                    >
                        {row.row.original.jobApplicationStatus === "Rejected" ? "Not Selected" : row.row.original.jobApplicationStatus}
                    </p>
                )
            }
        })
    ]

    const tableInstance = useReactTable({
        data: jobAppellantDataList,
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })
    return (
        <div>
            {
                totalAppellents ? 
                (
                    <>
                    <ReactTable tableInstance={tableInstance} />
                    <div className="paginationbox">
                        <div className="showingpages">
                        <span>
                                                Showing{' '}
                                                {(currentPage - 1) * DataLimit + 1} to{' '}
                                                {Math.min(
                                                    currentPage * DataLimit,
                                                    totalAppellents
                                                )}{' '}
                                                of {totalAppellents} Applicants
                                            </span>
                        </div>
                        <div className="itemsperpage">
                            <span>Items per page:</span>
                            <Dropdown flip="no" onSelect={handleChange}>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                  {DataLimit}
                                </Dropdown.Toggle>
        
                                <Dropdown.Menu>
                                    <Dropdown.Item eventKey="10">10</Dropdown.Item>
                                    <Dropdown.Item eventKey="20">20</Dropdown.Item>
                                    <Dropdown.Item eventKey="30">30</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                       {totalAppellents > DataLimit && 
                       (
                        <div className="pagination">
                            <Pagination
                            total={Math.ceil(
                                totalAppellents / DataLimit
                            )}
                            current={currentPage}
                            onChangePage={handleChangePage}
                            
                            />
                        </div>
                       )
                       }
                    </div>
                    </>
                ) :
                (
                    <div className="noresult">
                    <p>No Result Found</p>
                </div>
                )
            }
         
        </div>
    )
}

export default AppellantComponent
